import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import { ConnectionResource } from '../../Types';
import AttributesCheck from '../AttributesCheck';
import AssignedDomains from './AssignedDomains';
import AttributesCard from './AttributesCard';
import ConnectionCard from './ConnectionCard';
import RemoveCard from './RemoveCard';
import SpDetailsCard from './SpDetailsCard';

interface Props {
  resource: ConnectionResource;
}

type State = { kind: 'overview' } | { kind: 'diagnostics' };

const Manage: React.FC<Props> = ({ resource }) => {
  const [state, setState] = React.useState<State>({ kind: 'overview' });

  switch (state.kind) {
    case 'diagnostics':
      return (
        <>
          <button
            type="button"
            className="mb-4 text-sm font-semibold text-primary hover:underline"
            onClick={() => setState({ kind: 'overview' })}
            data-intercom-target="sso-back-to-overview-link"
          >
            &larr; <T kind="Back to connection overview" />
          </button>
          <AttributesCheck
            resource={resource}
            onDone={just(() => setState({ kind: 'overview' }))}
          />
        </>
      );
    case 'overview':
      return (
        <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-5">
          <div className="flex flex-col gap-6 lg:col-span-3">
            <ConnectionCard resource={resource} />
            <SpDetailsCard resource={resource} />
            <AttributesCard
              resource={resource}
              onOpenDiagnostics={() => setState({ kind: 'diagnostics' })}
            />
          </div>
          <div className="flex flex-col gap-6 lg:col-span-2">
            <AssignedDomains resource={resource} />
            <RemoveCard resource={resource} />
          </div>
        </div>
      );
  }
};

export default observer(Manage);
